import { inputBasicAction } from '@/js/pages/entry/input-basic';
import { inputDetailAction } from '@/js/pages/entry/input-detail';
import { setLunchEnableChange } from '@/js/pages/manage/entry-edit';

const main = () => {
    if (!document.querySelector('#page-entry-edit-entry')) return false;
    inputBasicAction();
    inputDetailAction();
    setLunchEnableChange();
}
export default main;